import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {Configuration} from "../../configuration/configuration.model";
import {LocaleService} from "../services/locale.service";
import {ConfigurationProvider} from "../../configuration/configuration.provider";

export type DateFormatType = 'timeOnly' | 'dateOnly' | 'dateAndTime' | 'custom';

@Pipe({
    name: 'localizedDate',
    pure: true,
    standalone: false
})
export class LocalizedDatePipe implements PipeTransform {

	private readonly formats: Map<DateFormatType, (config: Configuration) => string> = new Map([
		["dateAndTime", c => c.dateTimeFormat],
		["dateOnly", c => c.dateFormat],
		["timeOnly", c => c.timeFormat],
	]);

	constructor(private localeService: LocaleService, private configProvider: ConfigurationProvider) {}

	transform(value: Date | null, type: DateFormatType = "dateOnly", customFormat?: string): Observable<string | null> {
		if (!value) return new Observable(observer => observer.next(null));

		return this.getFormat(type, customFormat).pipe(
			map(format => {
				const locale = this.localeService.resolveLocale();
				const datePipe = new DatePipe(locale);
				return datePipe.transform(value, format);
			})
		);
	}

	private getFormat(type: DateFormatType, customFormat?: string): Observable<string> {
		if (type === "custom" && customFormat) {
			return new Observable(observer => observer.next(customFormat));
		}

		return this.configProvider.getConfiguration().pipe(
			map(config => this.formats.get(type)(config))
		);
	}
}
